// src/utils/cat.js
export default async function getcat() {
    // Список ваших локальных картинок из папки public
    const localCats = [
        '/cat1.png',
        '/cat2.png',
        '/cat3.png'
    ];
    const randomIndex = Math.floor(Math.random() * localCats.length);
    return localCats[randomIndex];
}